import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const fetchWipBooked = async (startDate: any, endDate: any) => {
  const result = await fetch(
    `${REACT_APP_ARPS_BASE_URL}/wip/booked?start=${startDate}&end=${endDate}`
  );
  const stations = await result.json();
  return stations;
};

export default fetchWipBooked;
